// 藏品相关接口
import request from '@/utils/request'

// 藏品详情
export function collectionDetails(id) {
  return request({
    url: `/cultureCantonDemoApi/collectionBasicInfoApi/getCollectionBasicInfoDetails?id=${id}`,
    method: 'get',
  })
}
